import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance70 = () => {
  let winners = [
    "439", "219", "524", "534"
  ];
  return <IndividualTable matchType={"8"} gender="F" event="70" subTitle="Puta" data={sampleData2} topRankCount="4" winners={winners} />;
};
export default Distance70;
